import { defineComponent as _defineComponent } from 'vue';
import { useAttrs } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Button',
    props: {
        variant: { type: String, required: false, default: "primary" },
        size: { type: String, required: false, default: "medium" }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const attrs = useAttrs();
        const __returned__ = { props, attrs };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
